import React from 'react';
import {ORDERS_ROUTE, orderDeliveryPresentation, orderStatusPresentation} from "../../util/Constants";
import {formatOrderDate} from "../../util/formatOrderDate";
import OrderItems from "./OrderItems";
import ShipmentCard from "./ShipmentCard";
import {useNavigate} from "react-router-dom";

const OrderCard = ({id, number, dateTime, items, price, status, shipment, deliveryType, deliveryFee}) => {
    const navigate = useNavigate()
    const st = orderStatusPresentation(status);
    const del = orderDeliveryPresentation(deliveryType);

    return (
        <div className="w-full lg:w-[calc(50%-0.5rem)]">
            <div className="overflow-hidden rounded-3xl border border-stone-200/70 bg-white shadow-sm">
                <button
                    type="button"
                    className="w-full border-b border-stone-100 bg-cream-50/50 px-5 py-4 text-left transition hover:bg-cream-100/80"
                    onClick={() => navigate(ORDERS_ROUTE + '/' + id)}
                >
                    <div className="flex flex-wrap items-center gap-2">
                        <span className="text-lg font-semibold text-bark-900">Заказ {number}</span>
                        <span className={st.tw}>{st.translation}</span>
                    </div>
                    {dateTime != null && (
                        <p className="mt-0.5 text-xs text-bark-500">{formatOrderDate(dateTime)}</p>
                    )}
                    <p className="mt-1 text-sm text-bark-600">Сумма: {price} ₽</p>
                    {deliveryType && (
                        <p className="mt-0.5 text-xs text-bark-500">
                            {del.label}
                            {Number(deliveryFee) > 0 ? ` · доставка ${deliveryFee} ₽` : ''}
                        </p>
                    )}
                </button>
                <div className="p-4">
                    <details className="group border-b border-stone-100 py-2">
                        <summary className="cursor-pointer list-none font-medium text-bark-800 marker:content-none [&::-webkit-details-marker]:hidden">
                            <span className="flex items-center justify-between">
                                Товары
                                <span className="text-bark-400 transition group-open:rotate-180">▼</span>
                            </span>
                        </summary>
                        <div className="mt-3">
                            <OrderItems items={items}/>
                        </div>
                    </details>
                    <details className="group py-2">
                        <summary className="cursor-pointer list-none font-medium text-bark-800 marker:content-none [&::-webkit-details-marker]:hidden">
                            <span className="flex items-center justify-between">
                                Адрес доставки
                                <span className="text-bark-400 transition group-open:rotate-180">▼</span>
                            </span>
                        </summary>
                        <div className="mt-3">
                            <ShipmentCard shipment={shipment}/>
                        </div>
                    </details>
                </div>
            </div>
        </div>
    );
};

export default OrderCard;
